module.exports = __webpack_public_path__ + "static/media/logo-iclouds.a22927da.svg";